import { styled } from "@mui/material/styles";
import { IconButton } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";

import { colors } from "@zapalacorp/tokens";
import { Button } from "Components/Form";

export const AddLogicButton = styled(Button)(() => ({
  whiteSpace: "nowrap",
}));

export const QuestionContainer = styled("div", {
  shouldForwardProp(propName) {
    return propName !== "isDragging";
  },
})(({ isDragging }: { isDragging?: boolean }) => ({
  opacity: isDragging ? 0.5 : 1,
  transition: "opacity 0.2s",
}));

export const LogicQuestionsWrapper = styled("div", {
  shouldForwardProp(propName) {
    return propName !== "borderRadius" && propName !== "isFocused" && propName !== "isDraggedOver";
  },
})(
  ({
    borderRadius,
    isFocused,
    isDraggedOver,
  }: {
    borderRadius: string;
    isFocused: boolean;
    isDraggedOver?: boolean;
  }) => ({
    display: "flex",
    flexDirection: "column",
    borderRadius,
    border: isDraggedOver
      ? `2px solid ${colors.brandBlue600}`
      : isFocused
      ? `1px solid ${colors.gray200}`
      : "none",
  })
);

export const LogicsContainer = styled("li", {
  shouldForwardProp(propName) {
    return propName !== "isFocused";
  },
})(({ isFocused }: { isFocused?: boolean }) => ({
  position: "relative",
  paddingLeft: "40px",
  listStyleType: "none",
  backgroundColor: "#FFFFFF",

  "&::before": {
    content: '""',
    position: "absolute",
    left: "20px",
    top: "50%",
    transform: "translateY(-50%)",
    width: "2px",
    height: "100%",
    backgroundColor: isFocused ? colors.brandBlue600 : colors.gray200,
  },
}));

export const LogicQuestionContent = styled("div", {
  shouldForwardProp(propName) {
    return propName !== "borderRadius";
  },
})(({ borderRadius }: { borderRadius: string }) => ({
  padding: "12px",
  display: "grid",
  gridTemplateColumns: "40px 10fr 4fr 4fr 40px",
  gap: "12px",
  borderRadius,
  background: colors.gray50,
  alignItems: "flex-start",
}));

export const LogicQuestionDescription = styled("div")(() => ({
  padding: "12px",
  display: "grid",
  gridTemplateColumns: "40px 1fr",
  gap: "12px",
  background: colors.gray25,
}));

export const DragQuestionButton = styled(IconButton, {
  shouldForwardProp(propName) {
    return propName !== "canDragQuestion";
  },
})(({ canDragQuestion }: { canDragQuestion?: boolean }) => ({
  height: "40px",
  width: "40px",
  cursor: canDragQuestion ? "grab" : "default",
}));

export const RemoveQuestionButton = styled(IconButton)(() => ({
  borderRadius: "8px",
  border: `1px solid ${colors.error500}`,
  color: colors.error500,
  height: "40px",
  width: "40px",

  "&:focus": {
    border: `1px solid ${colors.error500}`,
  },

  "&:disabled": {
    color: colors.gray300,
    border: `1px solid ${colors.gray300}`,
  },
}));

export const LogicQuestionActions = styled("div", {
  shouldForwardProp(propName) {
    return propName !== "hasLogic";
  },
})(({ hasLogic }: { hasLogic: boolean }) => ({
  display: "flex",
  padding: "12px",
  gap: "12px",
  alignItems: "center",
  backgroundColor: colors.gray100,
  borderRadius: hasLogic ? "0 0 0 12px" : "0 0 12px 12px",
}));

export const ActionsDivider = styled("div")(() => ({
  width: "1px",
  height: "32px",
  backgroundColor: colors.gray200,
}));

export const ActionSwitchContainer = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
  flexWrap: "nowrap",
}));

export const ActionsText = styled("span")(() => ({
  color: colors.gray600,
  fontFamily: "Manrope",
  fontSize: "14px",
  lineHeight: "20px",
  letterSpacing: "0.25px",
  marginLeft: "4px",
  whiteSpace: "nowrap",
}));

export const OptionsErrorSection = styled("div")(() => ({
  fontFamily: "Manrope",
  fontSize: "14px",
  lineHeight: "24px",
  color: colors.error600,
  alignItems: "center",
  display: "flex",
  flex: 1,
  justifyContent: "flex-end",
}));

const styles = makeStyles(() => ({
  tabPanel: {
    padding: 0,
    border: "none",
  },
  tabsContainer: {
    "& > div:first-child": {
      backgroundColor: colors.gray200,
      margin: "12px 12px 0 12px",
      borderBottom: `2px solid ${colors.gray400}`,
    },
  },
  leftPanel: {
    marginTop: 0,
    marginLeft: "16px",
    paddingTop: "0 !important",
    paddingLeft: "0 !important",
    backgroundColor: colors.gray200,
  },
  leftPanelContainer: {
    "& > div": {
      marginTop: 0,
    },
  },
  iconError: {
    marginRight: "5px",
    fontSize: "16px",
  },
}));

export default styles;
